import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const translationsSlice = createSlice({
  name: 'translations',
  initialState,
  reducers: {
    update: (state, { payload }) => payload,
    reset: () => initialState,
  },
});

export const { update: updateTranslations, reset: resetTranslations } = translationsSlice.actions;

export default translationsSlice.reducer;
